"use client";

import Image from "next/image";


export default function WhatsAppIcon() {
    const whatsappMessage = encodeURIComponent("");
    const whatsappLink = `https://wa.me/23055111603?text=${whatsappMessage}`;

    return (
    <Image src={'/images/whatsapp-icon.png'} className='cursor-pointer' alt='' width={55} height={80} onClick={() => window.open(whatsappLink, "_blank")}></Image>
    )
}
